export const TRANSLATIONS = {
  tr: {
    "references.title": "Referanslarımız",
    "references.description": "Birlikte çalıştığımız markalarla tanışın.",
    "references.visitSite": "Web sitesini ziyaret et",
    "references.viewAll": "Tüm referansları gör",
    "references.viewReferences": "Referanslarını incele",
    "references.collaborations.title": "Ortak Çalışmalar",
    "references.collaborations.description": "Ortak çalışmalar yürüttüğümüz yazılım şirketleri ve referansları.",
    "apps.nav": "Uygulamalar",
    "apps.github": "GitHub’da incele",
    "apps.title": "Günlük hayatınızda Verasist",
    "apps.description": "Verasist Finance ve Diet, Verasist API ve SDK’sıyla çalışan yapay zekâ asistanlarını günlük takiple birleştirir.",
    "apps.finance.description": "Portföyünüzü, gelir-giderinizi ve birikim hedeflerinizi tek yerde takip edin. Verasist destekli asistanla finans kayıtlarınız üzerine sohbet edin, farklı senaryoları inceleyin.",
    "apps.finance.cta": "Finance’ı keşfet",
    "apps.diet.description": "Öğünlerinizi ve su tüketiminizi kaydedin, beslenme planınızı takip edin. Verasist destekli asistanla planınızı oluşturun ve günlük kayıtlarınızı sohbet ederek yönetin.",
    "apps.diet.cta": "Diet’i keşfet",
    "footer.links.kufibotGithub": "Kufibot · GitHub",
    "kufibot.title": "Kufibot ile tanışın",
    "kufibot.description": "Kufibot, Verasist API ve SDK’sıyla çalışan ROS 2 tabanlı sesli bir ev asistanı robotudur. Verasist’in entegrasyonları ve iş akışlarıyla farklı asistan görevlerine uyarlanabilir.",
    "kufibot.imageAlt": "El sallayan sarı Kufibot ev asistanı robotu",
    "kufibot.github": "GitHub’da incele",
    "nav.product": "Ürün",
    "nav.stack": "Yığın",
    "nav.integrations": "Entegrasyonlar",
    "nav.industries": "Sektörler",
    "nav.pricing": "Fiyatlandırma",
    "nav.faq": "SSS",
    "nav.docs": "Dokümantasyon",
    "nav.login": "Giriş Yap",

    "hero.badge": "Canlı sesli ajan demosu · şimdi konuşun",
    "hero.title1": "Sesli ve Yazılı",
    "hero.title2": "Yapay Zeka",
    "hero.title3": "Asistanları",
    "hero.subtitle": "Telefonu açan, soruları yanıtlayan, randevu alan ve 7/24 kişisel ve kurumsal hizmet veren sesli AI ajanları — insan kadar doğal, ekipten daha hızlı.",
    "hero.cta.talk": "Ajanla Konuş",
    "hero.cta.start": "Hemen Başla",
    "hero.video.pause": "Videoyu duraklat",
    "hero.video.play": "Videoyu oynat",

    "product.eyebrow": "Ürün",
    "product.title1": "Destek ekibinizin ihtiyacı olan",
    "product.title2": "her şey",
    "product.title3": ".",
    "product.subtitle": "Çağrı merkezi ekibinizin yanına; randevu alan, satış kapatan ve destek veren sesli AI ajanları. Hepsi tek platformda, gerçek insanlar gibi konuşur.",
    "product.integrationBadge": "50+ Entegrasyon · CRM, e-ticaret, telefon, muhasebe ve daha fazlası",

    "terminal.eyebrow": "Yapay Zeka Destekli Kurulum",
    "terminal.title1": "Yazarak",
    "terminal.title2": "inşa edin.",
    "terminal.subtitle": "Verasist, MCP (Model Context Protocol) sunucusu ile birlikte gelir. Claude Code, Cursor veya tercih ettiğiniz herhangi bir ajan ortamını bağlayın; sesli ajanlarınızı IDE'den çıkmadan oluşturun, düzenleyin ve canlıya alın.",
    "terminal.worksWith": "Şununla çalışır: Claude Code · Cursor · Codex · Herhangi MCP istemcisi",
    "terminal.helper": "Aynı tek satır komutla aramadan önce CRM çağrısı, çalıştırma kaydı veya e-imza entegrasyonu ekleyin",

    "stack.eyebrow": "§ Sizin Yığınınız",
    "stack.title1": "Her",
    "stack.title2": "kutuyu",
    "stack.title3": "değiştirin.",
    "stack.subtitle": "Hattaki her blok modellerini istediğiniz gibi değiştirip en uygun çözümleri sunuyoruz.  Gelen kanal, STT, LLM, TTS ve telefon altyapısını kendiniz seçin — ya da kademeyi tamamen atlayıp tüm boru hattını speech-to-speech’e çevirin.",
    "stack.hint": "Bizimle İletişime geçin, yığınınızı birlikte planlayalım.",
    "stack.inboundLabel": "Gelen Kanal",
    "stack.inboundValue": "Gelen Çağrı · NetGSM",
    "stack.production": "Yapay Zeka Ajanı",
    "stack.productionValue": "Yığınınız, canlı",
    "stack.live": "Canlı",

    "humanVoice.eyebrow": "Hibrit Ses Teknolojisi",
    "humanVoice.title1": "İnsan kulağıyla",
    "humanVoice.title2": "insan sesi",
    "humanVoice.title3": ".",
    "humanVoice.subtitle": "Markanızın sesinden önceden kaydedilen gerçek replikleri canlı TTS çıktısıyla aynı ses kimliğinde harmanlıyoruz. Sık görülen sorulara gerçek bir ses kaydıyla, anlık cevaplara ise canlı üretimle dönüyoruz. Sonuç: müşteri konuştuğunun bot olduğunu fark etmiyor.",
    "humanVoice.metric": "daha yüksek dönüşüm oranı",
    "humanVoice.bullet1": "Konuşma sırasında kesintisiz tek bir ses tonu.",
    "humanVoice.bullet2": "3 kata kadar daha düşük gecikme — gerçek konuşma hızı.",
    "humanVoice.bullet3": "Markanıza özel ses klonu (voice cloning) desteği.",
    "humanVoice.bullet4": "Acil/hassas kelimelerde otomatik insan temsilciye aktarım.",

    "process.eyebrow": "Süreç",
    "process.title1": "14 günde",
    "process.title2": "yayına alın",
    "process.title3": ".",
    "process.subtitle": "Mevcut numaranızı kullanın ya da yeni bir hat alın. Sesli ajanınız markanızın dilini öğrenir ve telefonlarınızı 7/24 karşılamaya başlar.",

    "integrations.eyebrow": "Entegrasyonlar",
    "integrations.titleTail": "ve daha fazlası",
    "integrations.subtitle": "Mevcut telefon hattınızı değiştirmenize gerek yok. Yerli operatörler, global ses sağlayıcıları ve popüler CRM/yardım masası araçlarıyla sesli ajanınızı saatler içinde yayına alıyoruz.",
    "integrations.helper": "Başka bir operatör veya yazılım mı kullanıyorsunuz? Demo sırasında birlikte planlayalım — çoğu sistemle SIP, REST ve webhook üzerinden hızlıca entegre olabiliyoruz.",

    "industries.eyebrow": "Sektörler",
    "industries.title1": "Düzenlemeli sektörler için",
    "industries.title2": "hazır",
    "industries.title3": ".",
    "industries.subtitle": "KVKK, GDPR ve sektöre özel uyumluluk gereksinimlerinizle uyumlu çalışırız. Hassas adımlarda otomatik insan aktarımı, kayıtlarda maskeleme ve denetim izleri standarttır.",

    "pricing.eyebrow": "Fiyatlandırma",
    "pricing.title": "İhtiyacınıza uygun fiyatlandırma",
    "pricing.subtitle": "İster yeni başlayın, ister ölçeklenin — size uygun bir planımız var.",
    "pricing.trustedBy": "KURUMSAL ÖLÇEKTE GÜVENİLİR",
    "pricing.popular": "En Popüler",
    "pricing.page.heroTitle": "Basit, ölçeklenebilir fiyatlandırma",
    "pricing.page.heroSubtitle": "İhtiyacınız olan her şey, hiçbir sürpriz ücret olmadan.",
    "pricing.page.compareTitle": "Özellik Karşılaştırması",
    "pricing.page.calculator.title": "Maliyetinizi Hesaplayın",
    "pricing.page.calculator.subtitle": "Aylık çağrı hacminize göre tahmini maliyetinizi görün.",
    "pricing.page.calculator.callsPerMonth": "Aylık çağrı sayısı",
    "pricing.page.calculator.callLength": "Ortalama çağrı süresi (dk)",
    "pricing.page.calculator.totalMonthly": "Tahmini Aylık Maliyet",
    "pricing.page.calculator.perMin": "/dk",
    "pricing.page.calculator.stt": "Konuşma Tanıma (STT)",
    "pricing.page.calculator.llm": "Dil Modeli (LLM)",
    "pricing.page.calculator.tts": "Ses Sentezi (TTS)",
    "pricing.page.calculator.hosting": "Platform Hosting",
    "pricing.page.compare.usage": "Kullanım ve Ölçek",
    "pricing.page.compare.hostingCost": "Platform Hosting Maliyeti",
    "pricing.page.compare.hostingCostDesc": "Model sağlayıcı maliyetleri hariç",
    "pricing.page.compare.modelCost": "Model Sağlayıcı Maliyeti (STT, LLM, TTS)",
    "pricing.page.compare.modelCostDesc": "Kendi API anahtarınızı getirirseniz $0",
    "pricing.page.compare.channels": "Kanallar",
    "pricing.page.compare.dataRetention": "Veri Saklama",
    "pricing.page.compare.security": "Güvenlik ve Uyumluluk",
    "pricing.page.compare.reliability": "Güvenilirlik ve Destek",
    "pricing.page.compare.concurrency": "Eşzamanlı Çağrı",
    "pricing.page.compare.build": "Kullanım Fiyatı",
    "pricing.page.compare.scale": "Kurumsal",
    "pricing.page.compare.minIncluded": "dk dahil",
    "pricing.page.compare.perLine": "/hat/ay",
    "pricing.page.compare.bringYourKey": "Kendi anahtarınızla $0",
    "pricing.page.compare.atCost": "Maliyetine",
    "pricing.page.compare.volumeBased": "Hacim bazlı",
    "pricing.page.compare.custom": "Özel",
    "pricing.page.compare.days14": "14 gün",
    "pricing.page.compare.daysCustom": "Özel",
    "pricing.page.compare.uptime": "Kurumsal seviye uptime",
    "pricing.page.compare.supportSLA": "Özel Destek SLA",
    "pricing.page.compare.dedicatedTeam": "Özel müşteri ekibi",
    "pricing.page.compare.community": "Topluluk, E-posta",
    "pricing.page.compare.noExtra": "—",
    "pricing.page.compare.check": "✓",
    "pricing.faq.title": "Sıkça Sorulan Sorular",
    "pricing.faq.q1": "Verasist'i ücretsiz deneyebilir miyim?",
    "pricing.faq.a1": "Evet! Demo için bizimle iletişime geçin ve birlikte ücretsiz deneme yapalım.",
    "pricing.faq.q2": "Sabit aylık ücretlendirme alabilir miyim?",
    "pricing.faq.a2": "Evet, Kurumsal planımız sabit platform ücreti ve taahhütlü hacimle çalışır. Satış ekibimizle görüşerek size özel bir plan oluşturabiliriz.",
    "pricing.faq.q3": "Hacim indirimi alabilir miyim?",
    "pricing.faq.a3": "Kesinlikle. Yüksek çağrı hacimleri için özel dakika başı fiyatlandırma sunuyoruz. Detaylar için satış ekibimizle iletişime geçin.",
    "pricing.faq.q4": "Dakika ücretlendirmesi nasıl çalışır?",
    "pricing.faq.a4": "Yalnızca ajanınızın konuştuğu dakikalar için ücretlendirilirsiniz. Bekleme, aktarma ve sessizlik süreleri ücrete dahil değildir. Dakika başı $0.05 platform ücretine ek olarak seçtiğiniz STT, LLM ve TTS model sağlayıcılarının maliyetleri eklenir.",
    "pricing.faq.q5": "Ölçeklendiğimde fiyatlandırma nasıl değişir?",
    "pricing.faq.a5": "Büyüdükçe özel fiyatlandırma, öncelikli destek ve özel hesap yönetimi sunuyoruz. Satış ekibimizle bir görüşme planlayarak size özel bir teklif hazırlayalım.",

    "blog.eyebrow": "Blog",
    "blog.title": "Sesli AI dünyasından içgörüler",
    "blog.viewAll": "Tüm yazılar",
    "blog.testimonials.eyebrow": "Müşteriler",
    "blog.testimonials.title": "Çağrı merkezi liderleri tarafından seviliyor",

    "faq.eyebrow": "Sıkça Sorulanlar",
    "faq.title1": "Sormaya değer",
    "faq.title2": "sorular",
    "faq.title3": ".",
    "faq.subtitle": "Mevcut altyapınız, verileriniz, dil desteği ve yayına alma süresi hakkında en sık duyduğumuz sorular.",
    "faq.noAnswer": "Cevabını bulamadığınız bir soru mu var?",
    "faq.askVera": "Vera'ya Sorun",

    "cta.title1": "Sesli ajanınızla",
    "cta.title2": "tanışmaya",
    "cta.title3": "hazır mısınız?",
    "cta.subtitle": "15 dakikalık canlı bir demo planlayın. Markanızın sesiyle konuşan bir ajanın gerçek aramalarda nasıl çalıştığını birlikte deneyelim.",
    "cta.primary": "Ücretsiz Sesli Demo Alın",
    "cta.secondary": "Fiyatları Gör",
    "cta.docs": "Dokümantasyon",

    "contact.eyebrow": "İletişim",
    "contact.title1": "Sorunuz mu var?",
    "contact.title2": "Konuşalım",
    "contact.title3": ".",
    "contact.subtitle": "Mevcut altyapınız, hedeflediginiz senaryolar veya özel entegrasyonlar için formu doldurun — 1 iş günü içinde döneriz.",
    "contact.email": "E-posta",
    "contact.phoneLabel": "Telefon (NetGSM hattı)",
    "contact.chatLabel": "Canlı sohbet",
    "contact.chatTime": "Hafta içi 09:00 – 18:00",

    "form.name": "Ad Soyad",
    "form.email": "E-posta",
    "form.phone": "Telefon",
    "form.company": "Şirket",
    "form.message": "Mesajınız",
    "form.send": "Mesajı Gönder",
    "form.sending": "Gönderiliyor…",
    "form.success.title": "Mesajınız alındı!",
    "form.success.message": "Bir iş günü içinde size geri dönüş yapacağız.",
    "form.success.new": "Yeni Mesaj",
    "form.error.contact": "Mesajınız gönderilemedi. Lütfen tekrar deneyin.",

    "appointment.title": "Ücretsiz Sesli Demo Randevusu",
    "appointment.subtitle": "30 dakikalık canlı demoda sesli ajanınızı birlikte test edelim.",
    "appointment.date": "Tercih edilen tarih",
    "appointment.time": "Saat",
    "appointment.infra": "Mevcut telefon altyapınız",
    "appointment.notes": "Notlar (isteğe bağlı)",
    "appointment.notesPlaceholder": "Kısaca kullanacağınız senaryoyu yazın: çağrı hacmi, dil, hedef…",
    "appointment.other": "Diğer / Bilmiyorum",
    "appointment.submit": "Randevuyu Al",
    "appointment.disclaimer": "Bilgileriniz yalnızca demoyu planlamak için kullanılır.",
    "appointment.success.title": "Randevunuz alındı!",
    "appointment.success.message": "Ekibimiz seçtiğiniz tarih ve saat için 1 iş günü içinde sizinle iletişime geçecek.",
    "appointment.close": "Kapat",
    "appointment.error": "Randevu oluşturulurken bir hata yaşandı. Lütfen tekrar deneyin.",

    "voiceAgent.title": "Vera ile konuşuyorsunuz",
    "voiceAgent.demo": "Demo",
    "voiceAgent.speaking": "Konuşuyor",
    "voiceAgent.listening": "Dinliyor",
    "voiceAgent.pickQuestion": "Bir soru seçin",
    "voiceAgent.simulation": "Bu canlı bir simülasyondur. Demo arama için randevu alın.",
    "voiceAgent.bookReal": "Gerçek Demo Randevusu",

    "agentAccess.choice.title": "Ajanla nasıl görüşmek istersiniz?",
    "agentAccess.choice.subtitle": "Size en uygun yöntemi seçin.",
    "agentAccess.choice.web.title": "Web üzerinden ara",
    "agentAccess.choice.web.desc": "Tarayıcınız üzerinden anında sesli görüşme başlatın.",
    "agentAccess.choice.phone.title": "Telefonla arama",
    "agentAccess.choice.phone.desc": "Ajanımız birkaç saniye içinde sizi telefonla arasın.",
    "agentAccess.lead.title": "Devam etmeden önce",
    "agentAccess.lead.subtitle": "Sizinle iletişime geçebilmemiz için birkaç bilgiye ihtiyacımız var.",
    "agentAccess.lead.name": "Ad Soyad",
    "agentAccess.lead.email": "E-posta",
    "agentAccess.lead.phone": "Telefon Numarası",
    "agentAccess.lead.phoneError": "Lütfen geçerli bir telefon numarası girin (örn. +90 5XX XXX XX XX).",
    "agentAccess.lead.submit": "Devam Et",
    "agentAccess.lead.submitting": "Gönderiliyor…",
    "agentAccess.lead.error": "Bilgileriniz gönderilemedi. Lütfen tekrar deneyin.",
    "agentAccess.lead.back": "Geri",
    "agentAccess.calling.title": "Aranıyorsunuz",
    "agentAccess.calling.message": "Ajanımız birkaç saniye içinde {phone} numarasını arayacak.",
    "agentAccess.calling.close": "Kapat",
    "agentAccess.calling.error": "Arama başlatılamadı. Lütfen daha sonra tekrar deneyin.",

    "callFlow.title": "Canlı Çağrı Akışı",
    "callFlow.todayCalls": "Bugün",
    "callFlow.callsLabel": "çağrı",
    "callFlow.avgResponse": "Ortalama yanıt",
    "callFlow.resolveRate": "Çözüm oranı",
    "callFlow.customer": "Müşteri",
    "callFlow.inbound": "Gelen Çağrı",
    "callFlow.sipTrunk": "SIP Trunk",
    "callFlow.voiceAI": "Sesli AI",
    "callFlow.crm": "CRM",
    "callFlow.autoLog": "Otomatik Kayıt",

    "liveCalls.title": "Canlı Görüşmeler",
    "liveCalls.active": "aktif",
    "liveCalls.kvkk": "Uyumlu · Kayıtta",
    "liveCalls.scenario1.industry": "Bankacılık",
    "liveCalls.scenario1.action": "Kart aktivasyonu · KYC doğrulama",
    "liveCalls.scenario1.status": "Çözüldü",
    "liveCalls.scenario2.industry": "Sigorta",
    "liveCalls.scenario2.action": "Trafik poliçesi yenileme teklifi",
    "liveCalls.scenario2.status": "Aktif",
    "liveCalls.scenario3.industry": "Sağlık",
    "liveCalls.scenario3.action": "Randevu hatırlatma · onay",
    "liveCalls.scenario3.status": "Çözüldü",
    "liveCalls.scenario4.industry": "E-ticaret",
    "liveCalls.scenario4.action": "Sipariş takibi · kargo bilgisi",
    "liveCalls.scenario4.status": "Çözüldü",
    "liveCalls.scenario5.industry": "Lojistik",
    "liveCalls.scenario5.action": "Teslimat saat değişikliği talebi",
    "liveCalls.scenario5.status": "İnsana aktarıldı",
    "liveCalls.scenario6.industry": "Telekom",
    "liveCalls.scenario6.action": "Tarife yenileme · kampanya",
    "liveCalls.scenario6.status": "Aktif",

    "footer.product": "Ürün",
    "footer.company": "Şirket",
    "footer.resources": "Kaynaklar",
    "footer.legal": "Yasal",
    "footer.description": "Markanızın sesiyle konuşan, müşterilerinizi 7/24 karşılayan modern sesli AI ajan platformu.",
    "footer.rights": "Tüm hakları saklıdır.",
    "footer.poweredBy": "",
    "footer.links.voiceAi": "Sesli AI Ajan",
    "footer.links.phone": "Telefon Karşılama",
    "footer.links.contactCenter": "Çağrı Merkezi",
    "footer.links.crm": "CRM Entegrasyonu",
    "footer.links.personalAssistant": "Kişisel Asistan",
    "footer.links.ecommerce": "E-Ticaret",
    "footer.links.chatbot": "Chat Bot",
    "footer.links.enterpriseAssistant": "Kurumsal Asistan",
    "footer.links.about": "Hakkımızda",
    "footer.links.careers": "Kariyer",
    "footer.links.press": "Basın",
    "footer.links.contact": "İletişim",
    "footer.links.blog": "Blog",
    "footer.links.helpCenter": "Yardım Merkezi",
    "footer.links.scenarioTemplates": "Senaryo Şablonları",
    "footer.links.docs": "Dokümantasyon",
    "footer.links.privacy": "Gizlilik",
    "footer.links.terms": "Şartlar",
    "footer.links.security": "Güvenlik",
    "footer.links.cookies": "Çerezler",
    "footer.links.dataDeletion": "Veri Silme Talebi",

    "product.badge": "50+ Entegrasyon · CRM, e-ticaret, telefon, muhasebe ve daha fazlası",
    "product.feature1.title": "Doküman ve Uygulama Entegrasyonu",
    "product.feature1.description": "Google Docs, Sheets, Notion ve benzeri uygulamalarla entegre çalışır; toplantı notlarını ve aksiyon maddelerini otomatik olarak ilgili dokümanlara işler.",
    "product.feature2.title": "7/24 Telefon Karşılama",
    "product.feature2.description": "Gelen ve giden çağrıları saniyeler içinde, doğal ses tonu ve duyguyla insan gibi yanıtlar; müşteriniz hiçbir zaman beklemede kalmaz.",
    "product.feature3.title": "Çoklu Dil Desteği",
    "product.feature3.description": "Türkçe, İngilizce, Almanca ve 30'dan fazla dilde aynı doğallıkla görüşme yapar.",
    "product.feature4.title": "CRM, Yardım Masası ve E-Ticaret Entegrasyonu",
    "product.feature4.description": "HubSpot, Microsoft Dynamics 365, Zendesk, Freshdesk ile tek tıkla bağlanır; Trendyol, Yemeksepeti gibi e-ticaret platformlarıyla entegre çalışır, her görüşme otomatik kaydedilir.",
    "product.feature5.title": "Sosyal Medya Entegrasyonu",
    "product.feature5.description": "WhatsApp, Telegram, Instagram ve daha fazlasıyla gelen mesajları otomatik yanıtlar, müşteriyle tek yerden konuşur.",
    "product.feature6.title": "Akıllı Transkript ve Özet",
    "product.feature6.description": "Her çağrı otomatik olarak yazıya dökülür, özetlenir ve aksiyon maddeleri çıkarılır.",

    "terminal.tools.claude": "Claude Code",
    "terminal.tools.cursor": "Cursor",
    "terminal.tools.codex": "Codex",
    "terminal.tools.openclaw": "OpenClaw",
    "terminal.tools.anyMcp": "Herhangi MCP",

    "stack.stage.stt.label": "Ses Tanıma",
    "stack.stage.stt.description": "Müşterinizi ne dediğini anlık olarak yazıya çevirir.",
    "stack.stage.llm.label": "Dil Modeli",
    "stack.stage.llm.description": "Niyeti anlar, bağlamı tutar, doğru cevabı üretir.",
    "stack.stage.tts.label": "Ses Sentezi",
    "stack.stage.tts.description": "Markanızın sesinde, insan kalitesinde konuşur.",
    "stack.stage.voice.label": "Telefon Altyapısı",
    "stack.stage.voice.description": "Mevcut numaranızla gelen-giden aramaları yönetir.",

    "process.step1.title": "Ücretsiz Keşif Görüşmesi",
    "process.step1.description": "30 dakikalık bir görüşmede çağrı akışınızı, kullandığınız sistemleri ve hedeflerinizi birlikte haritalandırırız.",
    "process.step2.title": "Sesli Ajan Eğitimi",
    "process.step2.description": "Markanızın ses kimliğini, senaryolarınızı ve sıkça gelen soruları ajana öğretiyoruz; gerçek aramalarla test ediyoruz.",
    "process.step3.title": "Telefon Hattına Bağlanma",
    "process.step3.description": "NetGSM, Verimor veya tercih ettiğiniz operatöre saatler içinde yayına alıyoruz; CRM'inizle gerçek zamanlı senkronize.",
    "process.step4.title": "Sürekli İyileştirme",
    "process.step4.description": "Aylık raporlar, çağrı kalitesi puanları ve A/B senaryolarla ajanınız her hafta biraz daha iyi konuşur.",

    "integrations.card.netgsm.name": "NetGSM",
    "integrations.card.netgsm.category": "Telefon Hattı",
    "integrations.card.netgsm.description": "Türkiye'nin lider VoIP sağlayıcılarından NetGSM ile sanal santral, SIP trunk ve toplu arama entegrasyonu — saatler içinde yayında.",
    "integrations.card.netgsm.badge": "Yerli Operatör",
    "integrations.card.verimor.name": "Verimor",
    "integrations.card.verimor.category": "Telefon Hattı",
    "integrations.card.verimor.description": "Verimor SIP trunk ve çağrı yönetimi API'leri ile gelen-giden aramalarınızı sesli ajanlara yönlendirin, kayıtları senkronize edin.",
    "integrations.card.verimor.badge": "Yerli Operatör",
    "integrations.card.twilio.name": "Twilio",
    "integrations.card.twilio.category": "Global Telefon",
    "integrations.card.twilio.description": "180+ ülkede sanal numara, programlanabilir ses ve uluslararası giden aramalar için Twilio Programmable Voice desteği.",
    "integrations.card.twilio.badge": "Global",
    "integrations.card.hubspot.name": "HubSpot",
    "integrations.card.hubspot.category": "CRM",
    "integrations.card.hubspot.description": "Her çağrı sonrası kişi kartı, görüşme özeti ve aksiyon maddeleri otomatik olarak HubSpot CRM'inize işlenir.",
    "integrations.card.hubspot.badge": "CRM",
    "integrations.card.salesforce.name": "Microsoft Dynamics 365",
    "integrations.card.salesforce.category": "CRM",
    "integrations.card.salesforce.description": "Sales, Customer Service ve Field Service modülleriyle gerçek zamanlı çalıştırma kayıtları, fırsat güncellemeleri ve vaka oluşturma.",
    "integrations.card.salesforce.badge": "CRM",
    "integrations.card.zendesk.name": "Zendesk",
    "integrations.card.zendesk.category": "Yardım Masası",
    "integrations.card.zendesk.description": "Çözülemeyen çağrılar otomatik olarak Zendesk ticket'ına dönüştürülür; transkript ve duygu skoru ile birlikte.",
    "integrations.card.zendesk.badge": "Destek",
    "integrations.card.whatsapp.name": "WhatsApp",
    "integrations.card.whatsapp.category": "Sosyal Medya",
    "integrations.card.whatsapp.description": "WhatsApp Business API ile mesajlaşma, bildirim ve müşteri hizmetleri otomasyonu.",
    "integrations.card.whatsapp.badge": "Mesajlaşma",
    "integrations.card.telegram.name": "Telegram",
    "integrations.card.telegram.category": "Sosyal Medya",
    "integrations.card.telegram.description": "Telegram Bot API ile anlık müşteri desteği, bildirim ve otomatik yanıtlar.",
    "integrations.card.telegram.badge": "Mesajlaşma",
    "integrations.card.instagram.name": "Instagram",
    "integrations.card.instagram.category": "Sosyal Medya",
    "integrations.card.instagram.description": "Instagram DM otomasyonu ile müşteri etkileşimi, hikaye yanıtları ve sipariş takibi.",
    "integrations.card.instagram.badge": "Sosyal",

    "integrations.card.trendyol.name": "Trendyol",
    "integrations.card.trendyol.category": "E-Ticaret",
    "integrations.card.trendyol.description": "Sipariş sorgulama, iade takibi ve müşteri sorularını Trendyol API entegrasyonu ile sesli ajana bağlayın.",
    "integrations.card.trendyol.badge": "Pazaryeri",
    "integrations.card.yemeksepeti.name": "Yemeksepeti",
    "integrations.card.yemeksepeti.category": "E-Ticaret",
    "integrations.card.yemeksepeti.description": "Canlı sipariş takibi, restoran desteği ve iptal/iade işlemlerini Yemeksepeti API üzerinden sesli yanıtlayın.",
    "integrations.card.yemeksepeti.badge": "Yemek",
    "integrations.card.hepsiburada.name": "Hepsiburada",
    "integrations.card.hepsiburada.category": "E-Ticaret",
    "integrations.card.hepsiburada.description": "Sipariş durumu, kargo takibi ve satıcı sorularını Hepsiburada entegrasyonu ile otomatik sesli hale getirin.",
    "integrations.card.hepsiburada.badge": "Pazaryeri",

    "industries.card.bank.name": "Bankacılık",
    "industries.card.bank.description": "Hesap işlemleri, kart aktivasyonu, dolandırıcılık doğrulaması.",
    "industries.card.insurance.name": "Sigorta",
    "industries.card.insurance.description": "Poliçe yenileme, hasar bildirimi, teklif takibi.",
    "industries.card.health.name": "Sağlık",
    "industries.card.health.description": "Randevu yönetimi, hatırlatma çağrıları, ön muayene bilgisi.",
    "industries.card.ecommerce.name": "E-ticaret",
    "industries.card.ecommerce.description": "Sipariş takibi, iade süreçleri, kampanya bilgilendirme.",
    "industries.card.telecom.name": "Telekom",
    "industries.card.telecom.description": "Tarife sorguları, kesinti bildirimleri, teknik destek.",
    "industries.card.legal.name": "Yasal Danışmanlık",
    "industries.card.legal.description": "Müvekkil ön elemesi, randevu, dosya durum bilgilendirme.",
    "industries.card.logistics.name": "Lojistik",
    "industries.card.logistics.description": "Sevkiyat takibi, teslimat planlaması, müşteri bildirimleri.",
    "industries.card.public.name": "Kamu",
    "industries.card.public.description": "Vatandaş bilgilendirme, başvuru durum sorguları, anketler.",

    "pricing.plan.paygo.name": "Kullandıkça Öde",
    "pricing.plan.paygo.badge": "KULLANIM BAZLI",
    "pricing.plan.paygo.description": "Sadece kullandığınız kadar ödeyin. Taahhüt yok, sürpriz yok.",
    "pricing.plan.paygo.feature1": "Kullanım bazlı dakika ücretlendirmesi",
    "pricing.plan.paygo.feature2": "Model maliyetleri müşteriye yansıtılır",
    "pricing.plan.paygo.feature3": "E-posta ve topluluk desteği",
    "pricing.plan.paygo.feature4": "Özel sesler ve model erişimi",
    "pricing.plan.paygo.feature5": "Görüşme Sonuç Analizi",
    "pricing.plan.paygo.feature6": "Yönetim Paneli ve Raporlama",
    "pricing.plan.paygo.cta": "Hemen Başla",

    "pricing.plan.custom.name": "Kurumsal",
    "pricing.plan.custom.badge": "YILLIK SÖZLEŞME",
    "pricing.plan.custom.description": "Özel ihtiyaçlarınız için tasarlanmış, ölçeklenebilir kurumsal çözüm.",
    "pricing.plan.custom.feature1": "Sabit platform ücreti ve taahhütlü hacim",
    "pricing.plan.custom.feature2": "Hacim bazlı dakika ücretlendirmesi",
    "pricing.plan.custom.feature3": "Kurumsal güvenlik: SOC 2, KVKK, SSO, RBAC",
    "pricing.plan.custom.feature4": "Veri yerleşimi (data residency)",
    "pricing.plan.custom.feature5": "Öncelikli model ve sağlayıcı erişimi",
    "pricing.plan.custom.feature6": "SLA destek",
    "pricing.plan.custom.feature7": "Özel müşteri temsilcisi",
    "pricing.plan.custom.cta": "Satışla İletişime Geç",
    "pricing.featuresTitle": "Pakette neler var",
    "pricing.detail": "Detaylar →",

    "blog.posts.post1.category": "Sesli AI",
    "blog.posts.post1.title": "Sesli AI Ajanlar Çağrı Merkezlerini Nasıl Dönüştürüyor?",
    "blog.posts.post1.excerpt": "Bekleme sürelerini sıfıra indiren, geceleri bile aynı kaliteyi koruyan sesli ajanların arkasındaki teknoloji.",
    "blog.posts.post1.date": "12 Haz 2026",
    "blog.posts.post1.readTime": "6 dk okuma",
    "blog.posts.post1.image": "/images/blog/ai-voice-assistant.jpg",
    "blog.posts.post2.category": "Müşteri Deneyimi",
    "blog.posts.post2.title": "İlk Çağrıda Çözüm Oranını %42 Artırmanın 5 Yolu",
    "blog.posts.post2.excerpt": "Akıllı yönlendirme, bağlam taşıma ve sesli ajan + insan iş birliğiyle CSAT skorlarınızı yükseltin.",
    "blog.posts.post2.date": "28 May 2026",
    "blog.posts.post2.readTime": "8 dk okuma",
    "blog.posts.post2.image": "/images/blog/business-handshake.jpg",
    "blog.posts.post3.category": "Teknoloji",
    "blog.posts.post3.title": "NetGSM ve Verimor ile Sesli AI Entegrasyonu Rehberi",
    "blog.posts.post3.excerpt": "Türkiye'deki en yaygın iki telefon altyapısına sesli ajanlarınızı nasıl bağlayacağınızın pratik anlatımı.",
    "blog.posts.post3.date": "14 May 2026",
    "blog.posts.post3.readTime": "5 dk okuma",
    "blog.posts.post3.image": "/images/blog/dashboard-analytics.jpg",

    "blog.testimonials.quote1": "Gece çağrı kuyruğumuz tamamen sıfırlandı. Sesli ajan, ekibimizin 3 katı performansla, üstelik daha sabırlı çalışıyor.",
    "blog.testimonials.author1": "Selin Aksoy",
    "blog.testimonials.role1": "CX Direktörü, Northwind",
    "blog.testimonials.quote2": "Müşterilerimiz ajanla konuştuğunu çoğu zaman fark etmiyor. NPS skorumuz 8 puan birden yükseldi.",
    "blog.testimonials.author2": "Marcus Reed",
    "blog.testimonials.role2": "Operasyon Müdürü, Reed & Co.",
    "blog.testimonials.quote3": "NetGSM hattımıza bir öğleden sonra entegre edildi. Ertesi gün gelen 1.200 çağrının %78'ini ajan tek başına çözdü.",
    "blog.testimonials.author3": "Priya Patel",
    "blog.testimonials.role3": "Destek Lideri, Bright Studio",

    "faq.item1.q": "Verim nerede saklanır? KVKK uyumlu mu?",
    "faq.item1.a": "Tüm görüşme verileri Türkiye veya seçtiğiniz AB bölgesindeki sunucularda şifreli olarak saklanır. KVKK ve GDPR uyumlu altyapıyla çalışırız; özel veri yerleşim talepleri için VPC kurulumu da yapıyoruz.",
    "faq.item2.q": "Mevcut çağrı merkezi yazılımımla nasıl entegre olur?",
    "faq.item2.a": "NetGSM, Verimor, Twilio gibi yaygın santral ve SIP sağlayıcılarla doğrudan, CRM ve yardım masası tarafında ise HubSpot, Microsoft Dynamics 365, Zendesk, Freshdesk ile hazır konnektörlerimiz var. Diğer sistemler için webhook, REST API ve SIP üzerinden saatler içinde entegre oluruz.",
    "faq.item3.q": "Türkçe ne kadar doğal konuşuyor?",
    "faq.item3.a": "Türkçe için optimize edilmiş ses modellerini ve markanıza özel ses klonlamayı destekliyoruz. Önceden kaydedilmiş gerçek replikleri canlı TTS ile harmanlayan hibrit yaklaşımımız sayesinde çoğu müşteri konuştuğu kişinin AI olduğunu fark etmiyor.",
    "faq.item4.q": "Hangi diller destekleniyor?",
    "faq.item4.a": "Türkçe, İngilizce, Almanca, Fransızca, İspanyolca ve Arapça dahil 30'dan fazla dil. Aynı görüşme içinde dil değişimi (örn. Türkçe ↔ İngilizce) da desteklenir.",
    "faq.item5.q": "Sesli ajan ne kadar sürede yayına alınır?",
    "faq.item5.a": "Standart kullanım senaryolarında demo görüşmesi dahil 7–14 iş günü içinde yayına alıyoruz. Acil ihtiyaçlar için hızlı kurulum paketimizle 72 saatlik teslimat opsiyonu mevcut.",
    "faq.item6.q": "İnsan temsilciye geçiş nasıl çalışıyor?",
    "faq.item6.a": "Ajan, müşterinin niyetini veya duygu durumunu algılayıp belirlediğiniz eşikte çağrıyı otomatik olarak insan temsilciye aktarır. Bağlam, transkript ve özet temsilciye tek tıkla aktarılır — müşteri tekrar anlatmak zorunda kalmaz.",
    "faq.item7.q": "Telefon hattını siz mi sağlıyorsunuz?",
    "faq.item7.a": "İsterseniz biz sağlayalım, isterseniz mevcut NetGSM, Verimor, Twilio veya kendi SIP trunk'unuzu kullanın. Numara taşıma desteği vardır; numaranızı değiştirmek zorunda değilsiniz.",
    "faq.item8.q": "Maliyet nasıl hesaplanıyor?",
    "faq.item8.a": "Aylık görüşme dakikası bazlı şeffaf fiyatlandırma. Saatlik fatura yok, gizli ücret yok. Detaylar için fiyatlandırma bölümüne göz atın veya demo randevusu alın.",

    "voiceDemo.intro": "Merhaba! Ben Vera, Verasist'in sesli AI asistanıyım. Telefonu nasıl açtığımı duymak için aşağıdaki sorulardan birini seçebilirsin.",
    "voiceDemo.qa1.q": "Hangi telefon altyapılarıyla çalışıyorsun?",
    "voiceDemo.qa1.a": "NetGSM, Verimor, Twilio ve SIP destekleyen her sistemle çalışıyoruz. Mevcut numaranızı taşımanıza gerek yok — kurulumdan sonra ilk aramayı saatler içinde karşılayabiliyorum.",
    "voiceDemo.qa2.q": "Türkçeyi ne kadar doğal konuşuyorsun?",
    "voiceDemo.qa2.a": "Türkçeye özel ses modelleriyle yetişiyorum. Markanızın tonunu ve sık tekrarlanan cümlelerinizi gerçek bir ses kaydı gibi söyleyebiliyorum; arada bir kahve molası bile veririm. Şaka bir yana, müşterilerin çoğu bot olduğumu fark etmiyor.",
    "voiceDemo.qa3.q": "Sigorta ekibimize uyar mı?",
    "voiceDemo.qa3.a": "Elbette — poliçe yenileme, hasar bildirim ön elemesi, ödeme hatırlatması gibi senaryoları ezbere biliyorum. Düzenleyici kurallarınızı senaryolara işliyoruz; hassas adımlarda görüşmeyi otomatik olarak insan temsilciye veriyorum.",
    "voiceDemo.qa4.q": "Bir aramayı nasıl insana aktarıyorsun?",
    "voiceDemo.qa4.a": "Müşterinin sesindeki duyguyu, sorunun karmaşıklığını ve sizin belirlediğiniz kuralları izliyorum. Aktarım gerektiğinde temsilciye konuşmanın özetini ve transkripti tek tıkla iletiyorum; müşteri tekrar anlatmak zorunda kalmıyor.",
    "voiceDemo.qa5.q": "Kayıtlar ve KVKK?",
    "voiceDemo.qa5.a": "Tüm görüşmeler Türkiye veya seçtiğiniz AB bölgesindeki sunucularda şifreli saklanıyor. KVKK ve GDPR uyumlu kayıt, saklama süreleri ve silme talepleri için panelde tek tıkla yönetim sunuyoruz.",
    "voiceDemo.outro": "Daha fazlasını mı duymak istersiniz? Gerçek bir demo randevusu alarak kendi senaryolarınızda canlı dinleyin.",

    "common.minRead": "dk okuma",
  },
  en: {
    "references.title": "Our References",
    "references.description": "Meet the brands we work with.",
    "references.visitSite": "Visit website",
    "references.viewAll": "View all references",
    "references.viewReferences": "View references",
    "references.collaborations.title": "Collaborations",
    "references.collaborations.description": "Explore the software companies we collaborate with and their references.",
    "apps.nav": "Apps",
    "apps.github": "View on GitHub",
    "apps.title": "Verasist in everyday life",
    "apps.description": "Verasist Finance and Diet combine everyday tracking with AI assistants powered by the Verasist API and SDK.",
    "apps.finance.description": "Track your portfolio, income, expenses, and savings goals in one place. Chat with a Verasist-powered assistant about your financial records and explore different scenarios.",
    "apps.finance.cta": "Explore Finance",
    "apps.diet.description": "Log meals and water intake, and follow your meal plan. Build your plan with a Verasist-powered assistant and manage daily entries through chat.",
    "apps.diet.cta": "Explore Diet",
    "footer.links.kufibotGithub": "Kufibot · GitHub",
    "kufibot.title": "Meet Kufibot",
    "kufibot.description": "Kufibot is a ROS 2 home assistant robot powered by the Verasist API and SDK for voice interaction. Verasist’s integrations and workflows let you adapt it to different assistant tasks.",
    "kufibot.imageAlt": "Yellow Kufibot home assistant robot waving",
    "kufibot.github": "Explore on GitHub",
    "nav.product": "Product",
    "nav.stack": "Stack",
    "nav.integrations": "Integrations",
    "nav.industries": "Industries",
    "nav.pricing": "Pricing",
    "nav.faq": "FAQ",
    "nav.docs": "Docs",
    "nav.login": "Log in",

    "hero.badge": "Live voice agent demo · talk now",
    "hero.title1": "Take care of your",
    "hero.title2": "customers",
    "hero.title3": "with Voice AI",
    "hero.subtitle": "Voice AI agents that answer phones, handle questions, book appointments and run 24/7 customer service — as natural as a human, faster than any team.",
    "hero.cta.talk": "Talk to Agent",
    "hero.cta.start": "Get Started",
    "hero.video.pause": "Pause video",
    "hero.video.play": "Play video",

    "product.eyebrow": "Product",
    "product.title1": "Everything your support team",
    "product.title2": "needs",
    "product.title3": ".",
    "product.subtitle": "Voice AI agents alongside your contact center team that book appointments, close sales and provide support. All in one platform, speaking like real humans.",
    "product.integrationBadge": "50+ Integrations · CRM, e-commerce, telephony, accounting and more",

    "terminal.eyebrow": "AI-Powered Setup",
    "terminal.title1": "Build by",
    "terminal.title2": "writing.",
    "terminal.subtitle": "Verasist ships with an MCP (Model Context Protocol) server. Connect Claude Code, Cursor or any agentic environment; create, edit and deploy your voice agents without leaving your IDE.",
    "terminal.worksWith": "Works with: Claude Code · Cursor · Codex · Any MCP client",
    "terminal.helper": "Add CRM lookups, call recording or e-signature with the same one-line command",

    "stack.eyebrow": "§ Your Stack",
    "stack.title1": "Swap every",
    "stack.title2": "box",
    "stack.title3": ".",
    "stack.subtitle": "Click any block on the right to see swappable providers. Pick your inbound channel, STT, LLM, TTS and telephony — or skip the cascade entirely and turn the whole pipeline speech-to-speech.",
    "stack.hint": "Click any box to swap",
    "stack.inboundLabel": "Inbound Channel",
    "stack.inboundValue": "Inbound Call · NetGSM",
    "stack.production": "Production Agent",
    "stack.productionValue": "Your stack, live",
    "stack.live": "Live",

    "humanVoice.eyebrow": "Hybrid Voice Tech",
    "humanVoice.title1": "Human ears,",
    "humanVoice.title2": "human voice",
    "humanVoice.title3": ".",
    "humanVoice.subtitle": "We blend pre-recorded real takes of your brand voice with live TTS output in the same vocal identity. Common phrases play back as a real recording while live answers stream from generative TTS. The result: customers don't notice it's a bot.",
    "humanVoice.metric": "higher conversion rate",
    "humanVoice.bullet1": "Seamless single vocal tone throughout the call.",
    "humanVoice.bullet2": "Up to 3x lower latency — true conversational pace.",
    "humanVoice.bullet3": "Custom voice cloning for your brand.",
    "humanVoice.bullet4": "Automatic hand-off to a human on sensitive keywords.",

    "process.eyebrow": "Process",
    "process.title1": "Go live in",
    "process.title2": "14 days",
    "process.title3": ".",
    "process.subtitle": "Use your existing number or get a new one. Your voice agent learns your brand and answers your calls 24/7.",

    "integrations.eyebrow": "Integrations",
    "integrations.titleTail": "and more",
    "integrations.subtitle": "You don't have to change your phone provider. We work with local carriers, global voice providers and popular CRM/help desk tools, going live in hours.",
    "integrations.helper": "Using another carrier or tool? Let's plan it together during the demo — we integrate with most systems in hours via SIP, REST and webhooks.",

    "industries.eyebrow": "Industries",
    "industries.title1": "Built for",
    "industries.title2": "regulated industries",
    "industries.title3": ".",
    "industries.subtitle": "We comply with KVKK, GDPR and sector-specific requirements. Automatic human hand-off on sensitive steps, recording redaction and audit trails are standard.",

    "pricing.eyebrow": "Pricing",
    "pricing.title": "Pricing that fits your needs",
    "pricing.subtitle": "Whether you're just starting out or scaling up — we have a plan for you.",
    "pricing.trustedBy": "TRUSTED AT ENTERPRISE SCALE",
    "pricing.popular": "Most Popular",
    "pricing.page.heroTitle": "Simple, scalable pricing",
    "pricing.page.heroSubtitle": "Everything you need, with no surprise fees.",
    "pricing.page.compareTitle": "Compare Features",
    "pricing.page.calculator.title": "Estimate Your Cost",
    "pricing.page.calculator.subtitle": "See your estimated monthly cost based on your call volume.",
    "pricing.page.calculator.callsPerMonth": "Calls per month",
    "pricing.page.calculator.callLength": "Average call length (min)",
    "pricing.page.calculator.totalMonthly": "Estimated Monthly Cost",
    "pricing.page.calculator.perMin": "/min",
    "pricing.page.calculator.stt": "Speech-to-Text (STT)",
    "pricing.page.calculator.llm": "Large Language Model (LLM)",
    "pricing.page.calculator.tts": "Text-to-Speech (TTS)",
    "pricing.page.calculator.hosting": "Platform Hosting",
    "pricing.page.compare.usage": "Usage and Scale",
    "pricing.page.compare.hostingCost": "Platform Hosting Cost",
    "pricing.page.compare.hostingCostDesc": "Excludes model provider costs",
    "pricing.page.compare.modelCost": "Model Provider Cost (STT, LLM, TTS)",
    "pricing.page.compare.modelCostDesc": "$0 if you bring your own API key",
    "pricing.page.compare.channels": "Channels",
    "pricing.page.compare.dataRetention": "Data Retention",
    "pricing.page.compare.security": "Security and Compliance",
    "pricing.page.compare.reliability": "Reliability and Support",
    "pricing.page.compare.concurrency": "Call Concurrency",
    "pricing.page.compare.build": "Pay As You Go",
    "pricing.page.compare.scale": "Enterprise",
    "pricing.page.compare.minIncluded": "min included",
    "pricing.page.compare.perLine": "/line/mo",
    "pricing.page.compare.bringYourKey": "$0 with own key",
    "pricing.page.compare.atCost": "At cost",
    "pricing.page.compare.volumeBased": "Volume based",
    "pricing.page.compare.custom": "Custom",
    "pricing.page.compare.days14": "14 days",
    "pricing.page.compare.daysCustom": "Custom",
    "pricing.page.compare.uptime": "Enterprise-grade uptime",
    "pricing.page.compare.supportSLA": "Custom Support SLA",
    "pricing.page.compare.dedicatedTeam": "Dedicated account team",
    "pricing.page.compare.community": "Community Discord, Email",
    "pricing.page.compare.noExtra": "—",
    "pricing.page.compare.check": "✓",
    "pricing.faq.title": "Frequently Asked Questions",
    "pricing.faq.q1": "Can I try Verasist for free?",
    "pricing.faq.a1": "Yes! Contact us for a demo and start your free trial together.",
    "pricing.faq.q2": "Can I get fixed monthly pricing?",
    "pricing.faq.a2": "Yes, our Enterprise plan offers a fixed platform fee with committed volume. Contact our sales team to build a custom plan for your needs.",
    "pricing.faq.q3": "Can I get volume discounts?",
    "pricing.faq.a3": "Absolutely. We offer custom per-minute pricing for high call volumes. Reach out to our sales team for details.",
    "pricing.faq.q4": "How does per-minute billing work?",
    "pricing.faq.a4": "You're only billed for the minutes your agent actually speaks. Hold time, transfers, and silence are not charged. On top of the $0.05/min platform fee, you pay the STT, LLM, and TTS model provider costs of your choice.",
    "pricing.faq.q5": "What happens to pricing when I scale?",
    "pricing.faq.a5": "As you grow, we offer custom pricing, priority support, and dedicated account management. Book a call with our sales team to get a tailored quote.",

    "blog.eyebrow": "Blog",
    "blog.title": "Insights from the voice AI world",
    "blog.viewAll": "View all articles",
    "blog.testimonials.eyebrow": "Customers",
    "blog.testimonials.title": "Loved by contact center leaders",

    "faq.eyebrow": "Frequently Asked",
    "faq.title1": "Questions worth",
    "faq.title2": "asking",
    "faq.title3": ".",
    "faq.subtitle": "The questions we hear most about your existing stack, data, language support and time to go live.",
    "faq.noAnswer": "Can't find an answer to your question?",
    "faq.askVera": "Ask Vera",

    "cta.title1": "Ready to",
    "cta.title2": "meet",
    "cta.title3": "your voice agent?",
    "cta.subtitle": "Book a 15-minute live demo. Hear how an agent that speaks in your brand voice handles real calls.",
    "cta.primary": "Get a Free Voice Demo",
    "cta.secondary": "See Pricing",
    "cta.docs": "Documentation",

    "contact.eyebrow": "Contact",
    "contact.title1": "Have a question?",
    "contact.title2": "Let's talk",
    "contact.title3": ".",
    "contact.subtitle": "Tell us about your existing stack, target scenarios or custom integrations — we get back within one business day.",
    "contact.email": "Email",
    "contact.phoneLabel": "Phone (NetGSM line)",
    "contact.chatLabel": "Live chat",
    "contact.chatTime": "Weekdays 9:00 AM – 6:00 PM",

    "form.name": "Full name",
    "form.email": "Email",
    "form.phone": "Phone",
    "form.company": "Company",
    "form.message": "Your message",
    "form.send": "Send Message",
    "form.sending": "Sending…",
    "form.success.title": "Message received!",
    "form.success.message": "We'll get back to you within one business day.",
    "form.success.new": "New Message",
    "form.error.contact": "Your message couldn't be sent. Please try again.",

    "appointment.title": "Free Voice Demo Booking",
    "appointment.subtitle": "Test your voice agent live in a 30-minute demo.",
    "appointment.date": "Preferred date",
    "appointment.time": "Time",
    "appointment.infra": "Current telephony stack",
    "appointment.notes": "Notes (optional)",
    "appointment.notesPlaceholder": "Briefly describe your use case: call volume, language, goal…",
    "appointment.other": "Other / Not sure",
    "appointment.submit": "Book Appointment",
    "appointment.disclaimer": "Your information is used only to schedule the demo.",
    "appointment.success.title": "Appointment booked!",
    "appointment.success.message": "Our team will contact you within one business day about your selected date and time.",
    "appointment.close": "Close",
    "appointment.error": "Something went wrong while creating the appointment. Please try again.",

    "voiceAgent.title": "You're talking with Vera",
    "voiceAgent.demo": "Demo",
    "voiceAgent.speaking": "Speaking",
    "voiceAgent.listening": "Listening",
    "voiceAgent.pickQuestion": "Pick a question",
    "voiceAgent.simulation": "This is a live simulation. Book a real call for a true demo.",
    "voiceAgent.bookReal": "Book Real Demo",

    "agentAccess.choice.title": "How would you like to talk to the agent?",
    "agentAccess.choice.subtitle": "Choose the method that works best for you.",
    "agentAccess.choice.web.title": "Call via web",
    "agentAccess.choice.web.desc": "Start a voice call instantly from your browser.",
    "agentAccess.choice.phone.title": "Phone call",
    "agentAccess.choice.phone.desc": "Our agent will call your phone within seconds.",
    "agentAccess.lead.title": "Before we continue",
    "agentAccess.lead.subtitle": "We need a few details so we can reach you.",
    "agentAccess.lead.name": "Full name",
    "agentAccess.lead.email": "Email",
    "agentAccess.lead.phone": "Phone number",
    "agentAccess.lead.phoneError": "Please enter a valid phone number (e.g. +90 5XX XXX XX XX).",
    "agentAccess.lead.submit": "Continue",
    "agentAccess.lead.submitting": "Submitting…",
    "agentAccess.lead.error": "We couldn't submit your details. Please try again.",
    "agentAccess.lead.back": "Back",
    "agentAccess.calling.title": "We're calling you",
    "agentAccess.calling.message": "Our agent will call {phone} within a few seconds.",
    "agentAccess.calling.close": "Close",
    "agentAccess.calling.error": "Couldn't start the call. Please try again later.",

    "callFlow.title": "Live Call Flow",
    "callFlow.todayCalls": "Today",
    "callFlow.callsLabel": "calls",
    "callFlow.avgResponse": "Avg response",
    "callFlow.resolveRate": "Resolution rate",
    "callFlow.customer": "Customer",
    "callFlow.inbound": "Inbound Call",
    "callFlow.sipTrunk": "SIP Trunk",
    "callFlow.voiceAI": "Voice AI",
    "callFlow.crm": "CRM",
    "callFlow.autoLog": "Auto Log",

    "liveCalls.title": "Live Conversations",
    "liveCalls.active": "active",
    "liveCalls.kvkk": "Compliant · Logging",
    "liveCalls.scenario1.industry": "Banking",
    "liveCalls.scenario1.action": "Card activation · KYC verification",
    "liveCalls.scenario1.status": "Resolved",
    "liveCalls.scenario2.industry": "Insurance",
    "liveCalls.scenario2.action": "Policy renewal quote",
    "liveCalls.scenario2.status": "Active",
    "liveCalls.scenario3.industry": "Healthcare",
    "liveCalls.scenario3.action": "Appointment reminder · confirmation",
    "liveCalls.scenario3.status": "Resolved",
    "liveCalls.scenario4.industry": "E-commerce",
    "liveCalls.scenario4.action": "Order tracking · shipping info",
    "liveCalls.scenario4.status": "Resolved",
    "liveCalls.scenario5.industry": "Logistics",
    "liveCalls.scenario5.action": "Delivery time change request",
    "liveCalls.scenario5.status": "Transferred to human",
    "liveCalls.scenario6.industry": "Telecom",
    "liveCalls.scenario6.action": "Tariff renewal · campaign",
    "liveCalls.scenario6.status": "Active",

    "footer.product": "Product",
    "footer.company": "Company",
    "footer.resources": "Resources",
    "footer.legal": "Legal",
    "footer.description": "A modern voice AI agent platform that speaks in your brand voice and serves your customers 24/7.",
    "footer.rights": "All rights reserved.",
    "footer.poweredBy": "",
    "footer.links.voiceAi": "Voice AI Agent",
    "footer.links.phone": "Phone Answering",
    "footer.links.contactCenter": "Contact Center",
    "footer.links.crm": "CRM Integration",
    "footer.links.personalAssistant": "Personal Assistant",
    "footer.links.ecommerce": "E-Commerce",
    "footer.links.chatbot": "Chat Bot",
    "footer.links.enterpriseAssistant": "Enterprise Assistant",
    "footer.links.about": "About",
    "footer.links.careers": "Careers",
    "footer.links.press": "Press",
    "footer.links.contact": "Contact",
    "footer.links.blog": "Blog",
    "footer.links.helpCenter": "Help Center",
    "footer.links.scenarioTemplates": "Scenario Templates",
    "footer.links.docs": "Documentation",
    "footer.links.privacy": "Privacy",
    "footer.links.terms": "Terms",
    "footer.links.security": "Security",
    "footer.links.cookies": "Cookies",
    "footer.links.dataDeletion": "Data Deletion",

    "product.badge": "50+ Integrations · CRM, e-commerce, telephony, accounting and more",
    "product.feature1.title": "Document & App Integrations",
    "product.feature1.description": "Works with Google Docs, Sheets, Notion and similar apps; automatically syncs meeting notes and action items to the right documents.",
    "product.feature2.title": "24/7 phone answering",
    "product.feature2.description": "Answers inbound and outbound calls in seconds with natural tone and human-like emotion; your customers never wait.",
    "product.feature3.title": "Multi-language support",
    "product.feature3.description": "Handles Turkish, English, German and 30+ languages with the same natural quality.",
    "product.feature4.title": "CRM, Help Desk & E-Commerce Integrations",
    "product.feature4.description": "Connects with HubSpot, Microsoft Dynamics 365, Zendesk and Freshdesk in one click; integrates with e-commerce platforms like Trendyol and Yemeksepeti; every conversation is logged automatically.",
    "product.feature5.title": "Social Media Integration",
    "product.feature5.description": "Auto-respond to incoming messages on WhatsApp, Telegram, Instagram and more — all from a single inbox.",
    "product.feature6.title": "Smart transcripts and summaries",
    "product.feature6.description": "Every call is transcribed, summarized and turned into action items automatically.",

    "terminal.tools.claude": "Claude Code",
    "terminal.tools.cursor": "Cursor",
    "terminal.tools.codex": "Codex",
    "terminal.tools.openclaw": "OpenClaw",
    "terminal.tools.anyMcp": "Any MCP",

    "stack.stage.stt.label": "Speech Recognition",
    "stack.stage.stt.description": "Turns what the customer says into text in real time.",
    "stack.stage.llm.label": "Language Model",
    "stack.stage.llm.description": "Understands intent, holds context and generates the right response.",
    "stack.stage.tts.label": "Speech Synthesis",
    "stack.stage.tts.description": "Speaks in your brand voice with human-quality output.",
    "stack.stage.voice.label": "Telephony Layer",
    "stack.stage.voice.description": "Manages inbound and outbound calls via your existing number.",

    "process.step1.title": "Free discovery call",
    "process.step1.description": "In a 30-minute conversation we map your call flow, systems and goals together.",
    "process.step2.title": "Voice agent training",
    "process.step2.description": "We teach the agent your brand voice, scenarios and common questions and test them with real calls.",
    "process.step3.title": "Connect to your phone line",
    "process.step3.description": "We launch you on NetGSM, Verimor or your preferred carrier in hours and sync with your CRM in real time.",
    "process.step4.title": "Continuous improvement",
    "process.step4.description": "Monthly reports, call quality scores and A/B scenarios help your agent sound better every week.",

    "integrations.card.netgsm.name": "NetGSM",
    "integrations.card.netgsm.category": "Phone Line",
    "integrations.card.netgsm.description": "Integrate NetGSM for virtual switchboard, SIP trunk and bulk calling within hours.",
    "integrations.card.netgsm.badge": "Local Carrier",
    "integrations.card.verimor.name": "Verimor",
    "integrations.card.verimor.category": "Phone Line",
    "integrations.card.verimor.description": "Route inbound and outbound calls to voice agents with Verimor SIP trunk and call management APIs.",
    "integrations.card.verimor.badge": "Local Carrier",
    "integrations.card.twilio.name": "Twilio",
    "integrations.card.twilio.category": "Global Telephony",
    "integrations.card.twilio.description": "Twilio Programmable Voice support for virtual numbers, programmable voice and international outbound calls.",
    "integrations.card.twilio.badge": "Global",
    "integrations.card.hubspot.name": "HubSpot",
    "integrations.card.hubspot.category": "CRM",
    "integrations.card.hubspot.description": "Each call automatically creates a contact card, summary and action items in HubSpot CRM.",
    "integrations.card.hubspot.badge": "CRM",
    "integrations.card.salesforce.name": "Microsoft Dynamics 365",
    "integrations.card.salesforce.category": "CRM",
    "integrations.card.salesforce.description": "Real-time call logs, opportunity updates and case creation for Sales, Customer Service and Field Service modules.",
    "integrations.card.salesforce.badge": "CRM",
    "integrations.card.zendesk.name": "Zendesk",
    "integrations.card.zendesk.category": "Help Desk",
    "integrations.card.zendesk.description": "Unresolved calls are automatically turned into Zendesk tickets with transcript and sentiment score.",
    "integrations.card.zendesk.badge": "Support",
    "integrations.card.whatsapp.name": "WhatsApp",
    "integrations.card.whatsapp.category": "Social Media",
    "integrations.card.whatsapp.description": "Automate messaging, notifications and customer service with WhatsApp Business API.",
    "integrations.card.whatsapp.badge": "Messaging",
    "integrations.card.telegram.name": "Telegram",
    "integrations.card.telegram.category": "Social Media",
    "integrations.card.telegram.description": "Instant customer support, notifications and auto-replies via Telegram Bot API.",
    "integrations.card.telegram.badge": "Messaging",
    "integrations.card.instagram.name": "Instagram",
    "integrations.card.instagram.category": "Social Media",
    "integrations.card.instagram.description": "Engage customers with Instagram DM automation, story replies and order tracking.",
    "integrations.card.instagram.badge": "Social",

    "integrations.card.trendyol.name": "Trendyol",
    "integrations.card.trendyol.category": "E-Commerce",
    "integrations.card.trendyol.description": "Connect order inquiries, return tracking and customer questions to your voice agent via Trendyol API integration.",
    "integrations.card.trendyol.badge": "Marketplace",
    "integrations.card.yemeksepeti.name": "Yemeksepeti",
    "integrations.card.yemeksepeti.category": "E-Commerce",
    "integrations.card.yemeksepeti.description": "Handle live order tracking, restaurant support and cancellation/refund requests through Yemeksepeti API with voice.",
    "integrations.card.yemeksepeti.badge": "Food",
    "integrations.card.hepsiburada.name": "Hepsiburada",
    "integrations.card.hepsiburada.category": "E-Commerce",
    "integrations.card.hepsiburada.description": "Automate order status, shipment tracking and seller inquiries with Hepsiburada integration via voice.",
    "integrations.card.hepsiburada.badge": "Marketplace",

    "industries.card.bank.name": "Banking",
    "industries.card.bank.description": "Account operations, card activation and fraud verification.",
    "industries.card.insurance.name": "Insurance",
    "industries.card.insurance.description": "Policy renewal, claim intake and quote tracking.",
    "industries.card.health.name": "Healthcare",
    "industries.card.health.description": "Appointment management, reminders and pre-visit information.",
    "industries.card.ecommerce.name": "E-commerce",
    "industries.card.ecommerce.description": "Order tracking, returns and campaign updates.",
    "industries.card.telecom.name": "Telecom",
    "industries.card.telecom.description": "Plan inquiries, outage notices and technical support.",
    "industries.card.legal.name": "Legal",
    "industries.card.legal.description": "Client triage, appointments and case status updates.",
    "industries.card.logistics.name": "Logistics",
    "industries.card.logistics.description": "Shipment tracking, delivery planning and updates.",
    "industries.card.public.name": "Public Sector",
    "industries.card.public.description": "Citizen updates, application status and surveys.",

    "pricing.plan.paygo.name": "Pay As You Go",
    "pricing.plan.paygo.badge": "USAGE BASED",
    "pricing.plan.paygo.description": "Pay only for what you use. No commitment, no surprises.",
    "pricing.plan.paygo.feature1": "Usage-based call minutes",
    "pricing.plan.paygo.feature2": "Model costs are passed on to customer",
    "pricing.plan.paygo.feature3": "Email and community support",
    "pricing.plan.paygo.feature4": "Custom voices and model access",
    "pricing.plan.paygo.feature5": "Call Outcome Analysis",
    "pricing.plan.paygo.feature6": "Admin Dashboard and Reporting",
    "pricing.plan.paygo.cta": "Get Started",

    "pricing.plan.custom.name": "Enterprise",
    "pricing.plan.custom.badge": "ANNUAL CONTRACT",
    "pricing.plan.custom.description": "Tailored, scalable enterprise solution for your specific needs.",
    "pricing.plan.custom.feature1": "Fixed platform fee and committed volume",
    "pricing.plan.custom.feature2": "Volume-based per minute pricing",
    "pricing.plan.custom.feature3": "Enterprise security: SOC 2, GDPR, SSO, RBAC",
    "pricing.plan.custom.feature4": "Data residency",
    "pricing.plan.custom.feature5": "Priority model and provider access",
    "pricing.plan.custom.feature6": "Support SLA",
    "pricing.plan.custom.feature7": "Dedicated account team",
    "pricing.plan.custom.cta": "Contact Sales",
    "pricing.featuresTitle": "What's included",
    "pricing.detail": "Details →",
    "pricing.custom": "Custom",

    "blog.posts.post1.category": "Voice AI",
    "blog.posts.post1.title": "How voice AI agents are transforming contact centers",
    "blog.posts.post1.excerpt": "The technology behind voice agents that reduce wait times and keep the same quality at night.",
    "blog.posts.post1.date": "Jun 12, 2026",
    "blog.posts.post1.readTime": "6 min read",
    "blog.posts.post1.image": "/images/blog/ai-voice-assistant.jpg",
    "blog.posts.post2.category": "Customer Experience",
    "blog.posts.post2.title": "5 ways to increase first-call resolution by 42%",
    "blog.posts.post2.excerpt": "Improve CSAT with smart routing, context carrying and voice agent + human collaboration.",
    "blog.posts.post2.date": "May 28, 2026",
    "blog.posts.post2.readTime": "8 min read",
    "blog.posts.post2.image": "/images/blog/business-handshake.jpg",
    "blog.posts.post3.category": "Technology",
    "blog.posts.post3.title": "Guide to voice AI integration with NetGSM and Verimor",
    "blog.posts.post3.excerpt": "Practical advice on how to connect your voice agents to the two most common phone stacks in Turkey.",
    "blog.posts.post3.date": "May 14, 2026",
    "blog.posts.post3.readTime": "5 min read",
    "blog.posts.post3.image": "/images/blog/dashboard-analytics.jpg",

    "blog.testimonials.quote1": "Our night call queue is completely gone. The voice agent performs at triple the capacity of our team and is even more patient.",
    "blog.testimonials.author1": "Selin Aksoy",
    "blog.testimonials.role1": "CX Director, Northwind",
    "blog.testimonials.quote2": "Our customers often don't notice they are speaking to an agent. Our NPS jumped by 8 points.",
    "blog.testimonials.author2": "Marcus Reed",
    "blog.testimonials.role2": "Operations Manager, Reed & Co.",
    "blog.testimonials.quote3": "We integrated it into our NetGSM line in one afternoon. The next day the agent handled 78% of 1,200 incoming calls on its own.",
    "blog.testimonials.author3": "Priya Patel",
    "blog.testimonials.role3": "Support Lead, Bright Studio",

    "faq.item1.q": "Where is my data stored? Is it KVKK compliant?",
    "faq.item1.a": "All conversation data is stored encrypted in Turkey or your chosen EU region. We work with KVKK and GDPR-friendly infrastructure and can also set up VPC deployments for sensitive data residency.",
    "faq.item2.q": "How does it integrate with my existing contact center software?",
    "faq.item2.a": "We have ready connectors for common PBX and SIP providers like NetGSM, Verimor and Twilio, and for CRM and help desks like HubSpot, Microsoft Dynamics 365, Zendesk and Freshdesk. Other systems can be integrated in hours via webhooks, REST APIs and SIP.",
    "faq.item3.q": "How natural is the Turkish voice?",
    "faq.item3.a": "We support Turkish-optimized speech models and custom voice cloning. Thanks to our hybrid approach that blends pre-recorded real takes with live TTS, many customers do not notice they are speaking to AI.",
    "faq.item4.q": "What languages are supported?",
    "faq.item4.a": "30+ languages including Turkish, English, German, French, Spanish and Arabic. We also support language switching within the same conversation.",
    "faq.item5.q": "How quickly can a voice agent go live?",
    "faq.item5.a": "We typically launch in 7–14 business days including the demo conversation. For urgent needs we offer a fast-track setup with delivery in 72 hours.",
    "faq.item6.q": "How does the handoff to a human work?",
    "faq.item6.a": "The agent detects the customer's intent or emotion and automatically transfers the call at the threshold you set. The context, transcript and summary are forwarded in one click so the customer doesn't have to repeat themselves.",
    "faq.item7.q": "Do you provide the phone line too?",
    "faq.item7.a": "We can provide it or you can use your existing NetGSM, Verimor, Twilio or your own SIP trunk. Number porting is available, so you do not need to change your number.",
    "faq.item8.q": "How is pricing calculated?",
    "faq.item8.a": "Transparent pricing based on monthly call minutes. No hourly billing and no hidden fees. See the pricing section or book a demo for details.",

    "voiceDemo.intro": "Hello! I’m Vera, Verasist’s voice AI assistant. Pick one of the questions below to hear how I answer calls.",
    "voiceDemo.qa1.q": "Which telephony stacks do you work with?",
    "voiceDemo.qa1.a": "We work with any system that supports NetGSM, Verimor, Twilio and SIP. You do not need to port your number — I can answer the first call within hours after setup.",
    "voiceDemo.qa2.q": "How natural is your Turkish?",
    "voiceDemo.qa2.a": "I am trained on Turkish-specific voice models. I can speak in your brand tone and repeat common phrases as if they were a real recording; and yes, most customers do not notice I am a bot.",
    "voiceDemo.qa3.q": "Will this fit our insurance team?",
    "voiceDemo.qa3.a": "Absolutely — I know flows like policy renewal, damage claim triage and payment reminders. We implement your regulatory rules into the scenarios and automatically hand off sensitive steps to a human.",
    "voiceDemo.qa4.q": "How do you transfer a call to a human?",
    "voiceDemo.qa4.a": "I monitor the customer’s emotion, the complexity of the issue and the rules you define. When a handoff is needed, I forward a summary and transcript to the representative in one click so the customer does not need to repeat themselves.",
    "voiceDemo.qa5.q": "Records and KVKK?",
    "voiceDemo.qa5.a": "All conversations are stored encrypted in Turkey or your chosen EU region. We provide one-click management for KVKK and GDPR-compliant retention and deletion requests.",
    "voiceDemo.outro": "Want to hear more? Book a real demo and listen in on your own scenarios.",

    "common.minRead": "min read",
  },
};
